// Initialize Fancyapps UI 6.0.33 for gallery links
Fancybox.bind('.gallery-fancybox-link', {
	// Basic configuration
	loop: false,
	zoomEffect: true,
	touch: false,
	
	// Carousel configuration
	Carousel: {
		Thumbs: false,
		Toolbar: {
			display: {
				left: [],
				middle: [],
				right: ['close']
			}
		}
	},
	
	// Theme and styling
	theme: 'light',
	
	// Event handlers
	on: {
		ready: (fancyboxRef) => {
			// Add custom class for styling
			fancyboxRef.getContainer()?.classList.add('fancybox--light');
		}
	}
});
